import { RemoteGetAllCurricularUnitsUser } from 'data/usecases';
import { GetAllCurricularUnitsUserUseCaseInterface } from 'domain/usecases';
import { makeApiUrlCurricularUnitsUser } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllCurricularUnitsUser =
  (): GetAllCurricularUnitsUserUseCaseInterface =>
    new RemoteGetAllCurricularUnitsUser(
      makeApiUrlCurricularUnitsUser(),
      makeAxiosHttpClient(),
    );
